export function checkObjects(objectRef, objectValues) {
  try {
    let list = objectValues.split(".");
    let g = null;
    for (let x in list) {
      if (+x === 0) {
        g = objectRef[list[x]];
      } else {
        g = g[list[x]];
      }
    }

    return g;
  } catch (err) {
    return {};
  }
}
/**
 * 
 * @param {Array} initColor 
 * @param {Array} endColor 
 * @param {Integer} parts 
 * @returns [100, 100, 100, 1]
 */
export function scaleColorsRGBA(initColor, endColor, parts = 10) {
  let a = initColor;
  let b = endColor;
  let c = parts;
  let r = [
    (b[0] - a[0]) / (c - 1),
    (b[1] - a[1]) / (c - 1),
    (b[2] - a[2]) / (c - 1),
  ];

  let colores = [];
  for (let i = 1; i < parts - 1; i++) {
    colores.push([a[0] + r[0] * i, a[1] + r[1] * i, a[2] + r[2] * i]);
  }
  colores.push(b);

  return colores;
}

export function getColorPalette(context, index) {
  let colors = []
  switch (context) {
    case 'traffic':
      colors = [
        '#DD9A2D', '#144A78', '#578EB0', '#9ca240', '#768a9a', '#75381E', '#13777E',
        '#836969', '#93754D', '#1D5B7D','#8d1d5b','#5b8d1d','#1d8d87','#923030','#6b924d']
      break;
    default:
      colors = ['#09ad23', '#f39511', '#c3081d', '#f5dd35', '#ce16ea',
      '#ae191b', '#990099', '#e40000', '#7c0000', '#a8368d']
      break;
  }
  return colors[index] !== undefined ? colors[index] : '#000'
}

export function getFileImage (mime_name) {
  
}